import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getUserById, resendVerificationEmail, changeEmail } from "../api/api";
import { MdEmail } from "react-icons/md";
import "../RegistrationVarification/RegistrationVerification.css";
import bgImage from "../../assets/images/brown-background.jpg";
import Swal from "sweetalert2";
import RegistraionFlowHeader from "../RegistraionFlowHeader/RegistraionFlowHeader";

const RegistrationVerification = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const emailParam = location.state?.email || null;

  const [currUser, setCurrUser] = useState(null);
  // const [userData, setUserData] = useState(null);
  const [updatedEmail, setUpdatedEmail] = useState(emailParam || "");
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const getDataFromLocal = async () => {
    try {
      const userDatas = localStorage.getItem("currentUser");
      if (!userDatas) return;

      const parsedUserData = JSON.parse(userDatas);
      setCurrUser(parsedUserData);
      setUpdatedEmail(emailParam || parsedUserData?.email);

      // if (parsedUserData?._id) {
      //   const currentUser = await getUserById({ user_id: parsedUserData._id });
      //   // setUserData(currentUser.data);
      // }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    getDataFromLocal();
  }, []);

  const verification = async () => {
    try {
      const userDatas = localStorage.getItem("currentUser");
      if (!userDatas) return;

      const parsedUserData = JSON.parse(userDatas);
      const currentUser = await getUserById({
        user_id: parsedUserData._id || parsedUserData.id,
      });
      console.log("4444444", JSON.stringify(currentUser));
      if (currentUser?.data?.verification_status === "1") {
        // navigate("/gender");
        navigate("/PaymentScreen");
      } else {
        alert("Please verify your email first.");
      }
    } catch (error) {
      console.error("Error in verification:", error);
    }
  };

  const ResendVerification = async () => {
    try {
      const userDatas = localStorage.getItem("currentUser");
      if (!userDatas) return;

      const parsedUserData = JSON.parse(userDatas);
      const response = await resendVerificationEmail(
        parsedUserData._id || parsedUserData.id
      );

      // alert(response?.message || "Verification email sent successfully.");
      Swal.fire({
        title: "Success",
        text: response?.message,
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (error) {
      console.error("Error in ResendVerification:", error);
      // alert("Something went wrong. Please try again.");
      Swal.fire({
        title: "Error",
        text: "Something went wrong. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const handleEmailChange = async () => {
    if (!updatedEmail.includes("@")) {
      alert("Please enter a valid email.");
      return;
    }

    try {
      setLoading(true);
      const userDatas = localStorage.getItem("currentUser");
      if (!userDatas) return;

      const parsedUserData = JSON.parse(userDatas);
      const values = {
        user_id: parsedUserData._id || parsedUserData.id,
        user_type: "user",
        email: updatedEmail,
      };
      console.log("resvalues1", values);

      const res = await changeEmail(values);
      console.log("res11111111", JSON.stringify(res));
      if (res?.success === true) {
        alert(res.message || "Email updated successfully.");
        setModalVisible(false);
      } else {
        alert(res.message || "Something went wrong.");
      }
    } catch (error) {
      console.error("Error updating email:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="verificationcontainer sechdr-toppding"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    ><div className="containerall">
        <RegistraionFlowHeader />
        {/* background-color: #ffffff99; */}
        <div className="verificatonSmallContainer">
          <div className="verificationicon-container">
            <MdEmail className="verificationemail-icon" />
          </div>

          <div className="verificationtext-container">
            <p className="verificationtext">
              A verification email has been sent to{" "}
              <span className="verificationemail-highlight">
                {updatedEmail || currUser?.email}
              </span>
              .
            </p>
            <p className="verificationtext">
              Please verify your account and then click "Next" once you're done.
            </p>
          </div>

          <button className="verificationnext-btn" onClick={verification}>
            Next
          </button>

          <div className="verificationresend-container">
            <p className="verificationtext">Didn't receive the email?</p>
            <button
              className="verificationresend-btn1"
              onClick={ResendVerification}
            >
              Resend Verification
            </button>
          </div>

          <div className="verificationtext verificationchange-email-link">
            <p>
              Want to change your email?{" "}
              <span
                className="verificationchange-link"
                onClick={() => setModalVisible(true)}
              >
                Click here!
              </span>
            </p>
          </div>
        </div>
        {/* Email Change Modal */}
        {modalVisible && (
          <div className="verificationmodal-overlay">
            <div className="verificationmodal-content">
              <button
                className="verificationmodal-close"
                onClick={() => setModalVisible(false)}
              >
                ✕
              </button>
              <h3>Change Your Email</h3>
              <input
                type="email"
                value={updatedEmail}
                onChange={(e) => setUpdatedEmail(e.target.value)}
                placeholder="Enter new email"
                className="verificationemail-input"
              />
              <button
                className="verificationsubmit-btn"
                onClick={handleEmailChange}
                disabled={loading}
              >
                {loading ? "Updating..." : "Submit"}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RegistrationVerification;
